export default function IconEdit({ className }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            className={className}
        >
            <path
                d="M9.37955 3.48864C9.70682 3.16136 9.70682 2.67045 9.37955 2.34318L7.90682 0.870455C7.57955 0.543182 7.08864 0.543182 6.76136 0.870455L0.625 7.00682V9.625H3.24318L9.37955 3.48864ZM7.33409 1.44318L8.80682 2.91591L7.57955 4.14318L6.10682 2.67045L7.33409 1.44318ZM1.44318 8.80682V7.33409L5.53409 3.24318L7.00682 4.71591L2.91591 8.80682H1.44318Z"
                fill="black"
            />
        </svg>
    )
}
